import { all, put, call, takeLatest, delay } from 'redux-saga/effects';

import * as actions from 'reducer/actionTypes'
import * as api from 'script/api'
import {isEmpty} from 'script/common';
import i18next from 'i18next'

export default function* fetchSetting() {

	yield all([
		takeLatest(actions.FETCH_I18N_LANGUAGE_REQUEST, getLanguage),
		takeLatest(actions.FETCH_GET_ACCOUNT_INFO_REQUEST, getAccountInfo),
		takeLatest(actions.FETCH_GET_ACCOUNT_LANGUAGE_REQUEST, setLanguage),
		takeLatest(actions.FETCH_SET_ACCOUNT_CHANGE_USERID_REQUEST, changeUserId),
		takeLatest(actions.FETCH_SET_ACCOUNT_CHANGE_PASSWORD_REQUEST, changePasswd),
	])
}

function* getLanguage() {
	try {
		const result = yield call(api.getLanguage)
		
		if (!result.data.resultCode > 0) {
			i18next.changeLanguage(result.data.value);
		}

		yield put({
			type: actions.FETCH_I18N_LANGUAGE_SUCCESS
		})
	}
	catch (error) {
		yield put({
			type: actions.FETCH_I18N_LANGUAGE_FAILURE,
			error:error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

function* getAccountInfo() {
	try {
		const result = yield call(api.getAccountInfo)
		if(!result.data.resultCode > 0){
			yield put({
				type: actions.FETCH_GET_ACCOUNT_INFO_SUCCESS,
				value: result.data.value
			})
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})

		yield put({
			type: actions.FETCH_GET_ACCOUNT_INFO_FAILURE,
			error:error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

function* setLanguage(params) {
	try {
		const result = yield call(api.setLanguage,params)

		// failed
		if (result.data.resultCode > 0) {
			yield put({
				type: actions.SET_ACCOUNT_ERRORLABEL,
				errorLabel: {lang:result.data.messageId}
			})

			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: "message.box.save.failed",
				isError: true
			})
		}
		// success
		else {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: "message.box.saved",
				isError: false
			})
			//reload
			yield put({
				type: actions.FETCH_GET_ACCOUNT_INFO_REQUEST
			})
			yield put({
				type: actions.FETCH_I18N_LANGUAGE_REQUEST
			})
		}

		yield put({
			type: actions.FETCH_GET_ACCOUNT_LANGUAGE_SUCCESS,
		})
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
		
		yield put({
			type: actions.FETCH_GET_ACCOUNT_LANGUAGE_FAILURE,
			error:error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

function* changeUserId(parmas) {
	try {
		const result = yield call(api.changeUserId,parmas)

		if (result.data.resultCode > 0) {
			if (isEmpty(result.data.errorLabel)) {
				yield put({
					type: actions.SET_ACCOUNT_ERRORLABEL,
					errorLabel: {loginId:result.data.messageId}, 
				})
			}
			else {
				yield put({
					type: actions.SET_ACCOUNT_ERRORLABEL,
					errorLabel: result.data.errorLabel
				})
			}
		} else {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: "message.box.setting.changed.id",
				isError: false
			})

			yield delay(2000)

			yield put({
				type: actions.FETCH_LOGOUT_REQUEST
			})
		}

		yield put({
			type: actions.FETCH_SET_ACCOUNT_CHANGE_USERID_SUCCESS,
		})
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
		
		yield put({
			type: actions.FETCH_SET_ACCOUNT_CHANGE_USERID_FAILURE,
			error:error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

function* changePasswd(params) {
	try {
		const result = yield call(api.changePasswd,params)

		// failed
		if (result.data.resultCode > 0) {
			if(isEmpty(result.data.errorLabel)){
				yield put({
					type: actions.SET_ACCOUNT_ERRORLABEL,
					errorLabel: {password:result.data.messageId}, 
				})
			} else {
				yield put({
					type: actions.SET_ACCOUNT_ERRORLABEL,
					errorLabel: result.data.errorLabel
				})
			}
		}
		// success
		else {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: "message.box.setting.changed.password",
				isError: false
			})

			yield delay(2000)

			yield put({
				type: actions.FETCH_LOGOUT_REQUEST
			})
		}

		yield put({
			type: actions.FETCH_SET_ACCOUNT_CHANGE_PASSWORD_SUCCESS,
		})
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
		yield put({
			type: actions.FETCH_SET_ACCOUNT_CHANGE_PASSWORD_FAILURE,
			error:error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}